export enum RefundMethods {
  WALLET = 'wallet',
  ORIGIN = 'origin',
  BANK_ACCOUNT = 'bankAccount',
  BOTH = 'both',
}
